<ng-container *ngIf="!hidden && module">
    <ms-widget-header [title]="module.title" [linkConfig]="headerLinkConfig" (linkClick)="handleHeaderNavigation()">
        <ng-container *msShowInEpcot="false">
            @if (showBetBuilderBadge) {
                <span class="bet-builder-icon">{{ sitecore.globalMessages.BetBuilderBadgeText }}</span>
            }
        </ng-container>
    </ms-widget-header>
    <div class="top-events-body">
        @for (pod of module.podData; track pod.podId; let i = $index) {
            <ms-top-events-pod [pod]="pod" [index]="i" />
        }
    </div>
</ng-container>
